/**
 * Service that exposes several routing options.
 */
export abstract class RouterService {
  /**
   * Navigates user back to previous page in the route tree.
   */
  public abstract navigateBack(): void;
}
